import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CdwCheckboxModule } from '@cdw-ae/common-ui-components-checkbox';
import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { FilterBarModule, MatcherComponentRegistryService } from '@cdw-ae/filter-bar-core';
import { NumberMatcherComponent } from './matchers/number.matcher';
import { OneOfMatcherComponent } from './matchers/one-of.matcher';
import { OuTreePickerMatcherComponent } from './matchers/ou-tree-picker/ou-tree-picker.matcher';
import { SelectFromMatcherComponent } from './matchers/select-from.matcher';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialLibraryModule,
    FilterBarModule,
    CdwCheckboxModule,
  ],
  declarations: [
    NumberMatcherComponent,
    OneOfMatcherComponent,
    SelectFromMatcherComponent,
  ],
  exports: [
    NumberMatcherComponent,
    OneOfMatcherComponent,
    SelectFromMatcherComponent,
  ],
})
export class FilterBarSelectionMatchersModule {
  constructor(private matcherRegistry: MatcherComponentRegistryService) {
    // Register selection matcher components
    this.matcherRegistry.registerComponent('numberMatch', NumberMatcherComponent);
    this.matcherRegistry.registerComponent('oneOf', OneOfMatcherComponent);
    this.matcherRegistry.registerComponent('selectFrom', SelectFromMatcherComponent);
    this.matcherRegistry.registerComponent('is', OneOfMatcherComponent);
    this.matcherRegistry.registerComponent('isNot', OneOfMatcherComponent);
    this.matcherRegistry.registerComponent('ouTreePicker', OuTreePickerMatcherComponent);
  }
}
